module.exports = __webpack_public_path__ + "ad50eafdf6352ffac0c73603e93efed0.png";